import React, { useState, useEffect, useContext } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography, Paper, alpha, Stack, Grid } from '@mui/material';
import Container from '@mui/material/Container';
import { InputAdornment } from '@mui/material';
import { TextField } from '@mui/material';
import Swal from 'sweetalert2';
import { useTheme } from '@mui/material/styles';

import { Modal, Row, Col } from '../../components/BootstrapToMUI';

import request from '../../services/Request';

export default function SSmodal(props) {
  const theme = useTheme();

  const getSSURL = `/screenSaver/`;
  const getAudioURL = `/getAudioByEmail/`;
  const updatSSURL = `/machines/updateSS`;
  const { rowData, showAdmin, user, setMachines, setRowData, ...rest } = props;

  const [ss, setSS] = useState([]);
  const [audio, setAudio] = useState([]);
  const [ssid, setSsid] = useState('None');
  const [auid, setAuid] = useState('None');
  const [idleTimer, setidleTimer] = useState('60');
  const [ssErr, setssErr] = useState('');

  const [isReady, setIsReady] = useState(false);

  const disableAudio = user?.feature?.disableAudio;

  useEffect(() => {
    if (props.show) {
      setIsReady(false);
      setidleTimer('60');
      let isCancelled = false;
      const belongTo =
        rowData && rowData.length > 0 ? (rowData[0].belongTo ? rowData[0].belongTo : '') : '';
      if (belongTo != '') {
        setSsid(
          rowData && rowData.length
            ? rowData[0].screenSaver
              ? rowData[0].screenSaver
              : 'None'
            : 'None'
        );

        setidleTimer(
          rowData && rowData.length
            ? rowData[0].time_to_idle
              ? rowData[0].time_to_idle
              : '60'
            : '60'
        );
        setAuid(
          rowData && rowData.length ? (rowData[0].audio ? rowData[0].audio : 'None') : 'None'
        );
        setssErr('');
        //getAllEmployees
        async function getSS() {
          request({
            method: 'get',
            url: getSSURL + belongTo,
          }).then((res) => {
            if (!isCancelled) {
              setSS(res.data);
            }
          });
        }

        async function getAudio() {
          request({
            method: 'get',
            url: getAudioURL + belongTo,
          }).then((res) => {
            if (!isCancelled) {
              setAudio(res.data);
            }
          });
        }

        getSS();
        getAudio();
        setIsReady(true);
        return () => {
          isCancelled = true;
        };
      }
    }
  }, [props.show]);

  const onSubmit = async (data) => {
    let finalAU = auid;
    let finalID = ssid;
    if (ssid === 'None') finalID = '';
    if (auid === 'None') finalAU = '';
    if (showAdmin) {
      const machineID = rowData.map((e) => e._id);
      request({
        method: 'patch',
        url: updatSSURL,
        data: {
          audio: finalAU,
          id: finalID,
          time_to_idle: idleTimer,
          machineID: machineID,
        },
      })
        .then((res) => {
          setssErr('');

          setMachines((prevMachines) =>
            prevMachines.map((e) =>
              machineID.includes(e._id)
                ? { ...e, audio: finalAU, screenSaver: finalID, time_to_idle: idleTimer }
                : e
            )
          );
          setRowData((prevRowData) =>
            prevRowData.map((e) => ({
              ...e,
              audio: finalAU,
              screenSaver: finalID,
              time_to_idle: idleTimer,
            }))
          );

          Swal.fire({
            text: `The screen saver has been selected`,
            icon: 'success',
          }).then(() => {
            props.onHide();
          });
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 404) {
              setssErr(err.response.data.message);
            }
          }
        });
    } else {
      Swal.fire({
        text: `You have no permission to change the screen saver`,
        icon: 'error',
      });
    }
  };

  const handleChange = async (event) => {
    setssErr('');
    setSsid(event.target.value);
  };

  const handleAU = async (event) => {
    setAuid(event.target.value);
  };

  const handleIdle = async (event) => {
    setidleTimer(event.target.value);
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Screen Saver & Audio Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box sx={{ px: 2, py: 1 }}>
          {/* Idle Timer */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 2,
              backgroundColor: alpha(theme.palette.info.main, 0.03),
              borderRadius: 1.5,
              border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                display: 'block',
                color: theme.palette.text.secondary,
                fontSize: '0.8rem',
              }}
            >
              Idle Timer
            </Typography>
            <TextField
              fullWidth
              label="Time to idle (seconds)"
              variant="outlined"
              value={idleTimer}
              type="number"
              size="small"
              InputProps={{
                endAdornment: <InputAdornment position="end">s</InputAdornment>,
              }}
              inputProps={{
                min: '30',
              }}
              onChange={handleIdle}
            />
          </Paper>

          {/* Screen Saver Selection */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.03),
              borderRadius: 1.5,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                display: 'block',
                color: theme.palette.text.secondary,
                fontSize: '0.8rem',
              }}
            >
              Screen Saver
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={7}>
                <FormControl fullWidth>
                  <InputLabel id="screen-saver-label">Select Screen Saver</InputLabel>
                  <Select
                    labelId="screen-saver-label"
                    label="Select Screen Saver"
                    value={ssid}
                    onChange={handleChange}
                    size="small"
                  >
                    <MenuItem key={'0'} value={'None'}>
                      None
                    </MenuItem>
                    {ss.map((m) => {
                      if (m.referPlano == null)
                        return (
                          <MenuItem key={m._id} value={m._id}>
                            {m.name}
                          </MenuItem>
                        );
                    })}
                  </Select>
                </FormControl>
                {ssErr != '' && (
                  <Typography variant="caption" sx={{ color: theme.palette.error.main, mt: 0.5, display: 'block' }}>
                    {ssErr}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={5}>
                <Button
                  onClick={() => {
                    window.open(`/screenSaverPreview/${ssid}`, 'mywin', 'width=1080,height=1920');
                  }}
                  fullWidth
                  disabled={ssid === '' || ssid === 'None' || !isReady}
                  variant="outlined"
                  color="primary"
                  size="small"
                >
                  Preview
                </Button>
              </Grid>
            </Grid>
          </Paper>

          {/* Audio Selection */}
          {!disableAudio && (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                backgroundColor: alpha(theme.palette.secondary.main, 0.03),
                borderRadius: 1.5,
                border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  mb: 1.5,
                  display: 'block',
                  color: theme.palette.text.secondary,
                  fontSize: '0.8rem',
                }}
              >
                Audio
              </Typography>
              <FormControl fullWidth>
                <InputLabel id="audio-label">Select Audio</InputLabel>
                <Select
                  labelId="audio-label"
                  label="Select Audio"
                  value={auid}
                  onChange={handleAU}
                  size="small"
                >
                  <MenuItem key={'0'} value={'None'}>
                    None
                  </MenuItem>
                  {audio.map((m) => {
                    if (m.referPlano == null)
                      return (
                        <MenuItem key={m._id} value={m._id}>
                          {m.name}
                        </MenuItem>
                      );
                  })}
                </Select>
              </FormControl>
            </Paper>
          )}

          {/* Submit Button */}
          <Button
            fullWidth
            onClick={onSubmit}
            disabled={ssid == ''}
            variant="contained"
            color="primary"
            sx={{ mt: 1, py: 1 }}
          >
            Apply Settings
          </Button>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
